import AppHeader from '../AppHeader'

export default {
  name: 'master-consumable-item-shop-stock-count-edit',
  created () {
    this.getConsumableItemCount()
    this.stockCheckPeriod()
    this.consumable_item_id = this.$route.params.consumable_item_id
  },
  data () {
    return {
      canValidate: true,
      consumableItemCount: {},
      consumable_item_id: '',
      isSaving: false,
      searchEnd: false,
      isStockCheckPeriod: false
    }
  },
  computed: {
    validation () {
      let justStockNumber = /^[0-9]*$/

      let validation = {
        just_stock_number: !!this.consumableItemCount.just_stock_number && justStockNumber.test(this.consumableItemCount.just_stock_number)
      }
      if (!this.canValidate) {
        Object.keys(validation).forEach(
          key => {
            validation[key] = true
          }
        )
      }
      return validation
    },
    validationAll () {
      if (!this.validation.just_stock_number) return false
      return true
    }
  },
  components: {
    AppHeader
  },
  methods: {
    async getConsumableItemCount () {
      this.searchEnd = false
      const data = {
        consumable_item_id: this.$route.params.consumable_item_id,
        shop_id: this.$route.params.shop_id
      }
      let res = await this.$store.dispatch('GET_CONSUMABLE_ITEM_SHOP_STOCK_COUNT_EDIT', data)
                                  .catch(err => {
                                    console.log(err)
                                    return
                                  })

      this.consumableItemCount = res.shop_consumable_item_count
      this.searchEnd = true
    },
    async onClickSave () {
      // 連打対応
      if (this.isSaving) return false
      this.isSaving = true

      // 保存処理
      await this.$store.dispatch('UPDATE_CONSUMABLE_ITEM_SHOP_STOCK_COUNT', {
        data: {
          id: this.consumableItemCount.id,
          shop_id: this.consumableItemCount.shop_id,
          consumable_item_id: this.consumableItemCount.consumable_item_id,
          shop_hold_on_place_id: this.consumableItemCount.shop_hold_on_place_id,
          just_stock_number: this.consumableItemCount.just_stock_number
        }
      })
      .catch(err => {
        console.error(err)
        return
      })

      this.$router.push({path: '/master_consumable_item/' + this.consumable_item_id + '/stock_count'})
    },
    onClickCancel () {
      this.$router.push({path: '/master_consumable_item/' + this.consumable_item_id + '/stock_count'})
    },
    async stockCheckPeriod () {
      const res = await this.$store.dispatch('STOCK_CHECK_PERIOD_STORE')
                                  .catch(err => {
                                    console.log(err)
                                    return
                                  })
      this.isStockCheckPeriod = res.data
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/master-consumable-item-shop-stock-count-edit.js